import { render, staticRenderFns } from "./UnderReview.vue?vue&type=template&id=eebb7938&scoped=true&"
import script from "./UnderReview.vue?vue&type=script&lang=js&"
export * from "./UnderReview.vue?vue&type=script&lang=js&"
import style0 from "./UnderReview.vue?vue&type=style&index=0&id=eebb7938&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eebb7938",
  null
  
)

export default component.exports